import React from 'react';
import { useLocation, useSearchParams, useNavigate } from 'react-router-dom';
import Sidebar from "../component/Sidebar";
import Topbar from "../component/Topbar";
import Footer from "../component/Footer";

const PaymentSuccess = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const paymentData = location.state?.paymentData || null;
  const errorMessage = location.state?.errorMessage || null;

  const invoiceid =
    searchParams.get('invoiceid') ||
    paymentData?.invoiceid ||
    searchParams.get('invoiceno') ||
    paymentData?.invoiceno;
  const orderno =
    searchParams.get('orderno') ||
    paymentData?.orderno ||
    paymentData?.orderNo;

  const handleGoToDashboard = () => navigate("/dashboard");
  const handleRetry = () => navigate("/deposit");

  return (
    <>
      <div id="layout-wrapper">
        <Topbar />
        <Sidebar />
        <div className="main-content">
          <div className="page-content">
            <div className="container-fluid">
              <div className="row justify-content-center mt-5">
                <div className="col-xl-5 col-lg-6 col-md-8">
                  <div className="card shadow-lg border-0 rounded-4 overflow-hidden">
                    <div className="card-body p-5 text-center">
                      <div className="mb-4">
                        <div
                          className="d-inline-flex align-items-center justify-content-center bg-success bg-opacity-10 text-success rounded-circle"
                          style={{ width: '80px', height: '80px' }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 38 38" fill="none">
                            <circle cx="19" cy="19" r="17.8" stroke="#20AF49" strokeWidth="2.4" />
                            <path d="M28.6772 9.54858C23.753 15.2877 19.665 21.3897 16.3286 27.8259C14.6497 24.4235 12.4349 21.4718 9.51514 19.1238C10.8069 19.1163 11.6503 19.1619 12.4106 19.447C13.3968 19.8169 14.2925 20.6179 15.7905 22.4998L16.2437 23.0691L16.6128 22.4412C18.8968 18.5575 21.4326 15.1981 24.1763 12.2693H24.1772C24.8628 11.5372 25.3625 11.0041 25.7837 10.6082C26.2026 10.2143 26.5184 9.98081 26.8257 9.83276C27.2858 9.6111 27.7746 9.55325 28.6772 9.54858Z" fill="#20AF49" stroke="#20AF49" />
                          </svg>
                        </div>
                      </div>

                      <h2 className="fw-bold mb-3">Payment Successful!</h2>
                      <p className="text-muted mb-4 fs-5">
                        {errorMessage || 'Your transaction has been completed successfully.'}
                      </p>

                      <div className="rounded-3 p-3 mb-4 text-start border">
                        {invoiceid && (
                          <div className="d-flex flex-column flex-sm-row justify-content-between border-bottom pb-3 mb-3 gap-1 gap-sm-3">
                            <span className="text-muted fw-semibold text-nowrap">Order No</span>
                            <span className="fw-bold text-sm-end" style={{ wordBreak: 'break-all' }}>{invoiceid}</span>
                          </div>
                        )}
                        {(!orderno && !invoiceid && paymentData?.paymentId) && (
                          <div className="d-flex flex-column flex-sm-row justify-content-between border-bottom pb-3 mb-3 gap-1 gap-sm-3">
                            <span className="text-muted fw-semibold text-nowrap">Transaction ID</span>
                            <span className="fw-bold text-sm-end" style={{ wordBreak: 'break-all' }}>{paymentData.paymentId}</span>
                          </div>
                        )}
                        <div className="d-flex justify-content-between">
                          <span className="text-muted fw-semibold">Status</span>
                          <span className="badge bg-success bg-opacity-10 text-success fw-bold px-3 py-2 rounded-pill">Completed</span>
                        </div>
                      </div>

                      <div className="d-grid gap-3">
                        <button className="btn btn-primary btn-lg rounded-3 fw-bold" onClick={handleGoToDashboard}>
                          <i className="bx bx-home-alt me-2"></i> Go to Dashboard
                        </button>
                        <button className="btn btn-outline-secondary btn-lg rounded-3 fw-bold" onClick={handleRetry}>
                          <i className="bx bx-refresh me-2"></i> Make Another Payment
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default PaymentSuccess;
